'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _jsxFileName = 'src/SureDesignSystem/Image/Image.js';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _ImageModule = require('./Image.module.css');

var _ImageModule2 = _interopRequireDefault(_ImageModule);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
/* eslint-disable jsx-a11y/alt-text */


var mime = require('mime-types');

var propTypes = {
  className: _propTypes2.default.string,
  src: _propTypes2.default.imageSrc,
  webp: _propTypes2.default.imageSrc,
  pictureClassName: _propTypes2.default.string
};
var defaultProps = {
  className: null,
  src: null,
  webp: null,
  pictureClassName: null
};

function Image(_ref) {
  var className = _ref.className,
      src = _ref.src,
      webp = _ref.webp,
      pictureClassName = _ref.pictureClassName,
      props = _objectWithoutProperties(_ref, ['className', 'src', 'webp', 'pictureClassName']);

  if (!webp) {
    var mimeType = mime.lookup(src);
    return _react2.default.createElement('picture', {
      className: pictureClassName,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 29
      },
      __self: this
    }, _react2.default.createElement('source', {
      srcSet: webp,
      type: 'image/webp',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 30
      },
      __self: this
    }), _react2.default.createElement('source', {
      srcSet: src,
      type: mimeType || undefined,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 31
      },
      __self: this
    }), _react2.default.createElement('img', _extends({
      src: src
    }, props, {
      className: (0, _classnames2.default)(_ImageModule2.default.image, className),
      __source: {
        fileName: _jsxFileName,
        lineNumber: 32
      },
      __self: this
    })));
  } else {
    return _react2.default.createElement('img', _extends({
      src: src
    }, props, {
      className: (0, _classnames2.default)(_ImageModule2.default.image, className),
      __source: {
        fileName: _jsxFileName,
        lineNumber: 41
      },
      __self: this
    }));
  }
}

Image.propTypes = propTypes;
Image.defaultProps = defaultProps;
exports.default = Image;